import {
  NOTIFICATION_CREATE,
  NOTIFICATION_DELETE,
  NOTIFICATION_UPDATE,
  NOTIFICATION_FETCH,
  NOTIFICATION_FETCH_SUCCESS,
  NOTIFICATION_FETCH_RESET,
  NOTIFICATIONS_FETCH,
  NOTIFICATIONS_FETCH_SUCCESS,
  NOTIFICATIONS_FETCH_RESET,
} from '../actions/types';

export const notificationFetch = id => {
  return {
    type: NOTIFICATION_FETCH,
    payload: id,
  };
};

export const notificationFetchSuccess = payload => {
  return {
    type: NOTIFICATION_FETCH_SUCCESS,
    payload: payload,
  };
};

export const notificationFetchReset = () => {
  return {
    type: NOTIFICATION_FETCH_RESET,
  };
};

export const notificationsFetch = payload => {
  return {
    type: NOTIFICATIONS_FETCH,
    payload: payload,
  };
};

export const notificationsFetchSuccess = payload => {
  return {
    type: NOTIFICATIONS_FETCH_SUCCESS,
    payload: payload,
  };
};

export const notificationsFetchReset = () => {
  return {
    type: NOTIFICATIONS_FETCH_RESET,
  };
};

export const notificationCreate = values => {
  return {
    type: NOTIFICATION_CREATE,
    payload: values,
  };
};

export const notificationUpdate = values => {
  return {
    type: NOTIFICATION_UPDATE,
    payload: values,
  };
};

export const notificationDelete = id => {
  return {
    type: NOTIFICATION_DELETE,
    payload: id,
  };
};
